<template>
    <div class="patient-signup-page" v-if="!signedUp">
        <b-form @submit="onSubmit">
            <b-container>
                <b-row align-h="center">
                    <b-col cols="3">
                        <b-form-group id="patient-gender-group" label-for="patient-gender-select" label="Gender:">
                            <b-form-select id="patient-gender-select" v-model="form.selectedGender" :options="form.genders"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group id="patient-birthday-group" label-for="patient-birthday-datepicker" label="Birthday:">
                            <date-picker id="patient-birthday-datepicker" placeholder="Select Birthday" :bootstrapStyling="true" v-model="form.selectedBirthday"></date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-button type="submit" variant="primary">Submit</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
        <div class="mt-3">
            <b-container>
                <b-row align-h="center">
                    <b-col cols="6">
                        <div id="patient-recaptcha" class="g-recaptcha" data-sitekey=process.env.RECAPTCHA_SITE_KEY></div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
    <div v-else>
        <b-container>
            <b-row align-h="center">
                <b-col cols="6">
                    <p>
                        You're signed up. Please note both the username and password 
                        and keep them in a safe place. If the password is lost, we 
                        are unable to recover it.
                    </p>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="1">
                    Username:    
                </b-col>
                <b-col cols="1">
                    <b>{{user.username}}</b>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="1">
                    Password:
                </b-col>
                <b-col cols="1">
                    <b v-if="form.viewPassword">{{user.password}}</b>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="2">
                    <b-form-checkbox v-model="form.viewPassword">View Password</b-form-checkbox>
                </b-col>
            </b-row>
        </b-container> 
    </div>
</template>

<script>
    import DatePicker from 'vuejs-datepicker';
    import Moment     from 'moment';
    import User       from '../../user.js';

    export default
    {
        name: 'Patient-Signup',
        components: {
            DatePicker
        },
        data ()
        {
            return {
                signedUp: false,
                user: {
                    username: '',
                    password: ''
                },
                form: {
                    viewPassword:     false,
                    selectedGender:   null,
                    selectedBirthday: null,
                    genders: [
                        { value: null, text: "Select one" },
                        { value: 0,    text: "Male" },
                        { value: 1,    text: "Female" }
                    ]
                }
            }
        },
        methods: {
            onSubmit
        },
        mounted: onMounted
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onSubmit( event )
    {
        var recaptchaResponse = grecaptcha.getResponse( this.recaptchaID );
        if( recaptchaResponse.length === 0 )
        {
            alert( "Please verify that you're a human" );
            return;
        }

        var _this    = this;
        var birthday = Moment( this.form.selectedBirthday ).format( "MM/DD/YYYY" );
        var gender   = _this.form.genders[ _this.form.selectedGender + 1 ].text;
        User.signUp(
                null,
                {
                    recaptchaResponse: recaptchaResponse,
                    userType:          User.UserEnum.PATIENT,
                    attributes: [
                        {
                            "key":		"gender",
                            "value":	gender
                        },
                        {
                            "key":		"birthdate",
                            "value":	birthday
                        }
                    ]
                },
                function successCallback( result )
                {
                    _this.user.username = result.username;
                    _this.user.password = result.password;
                    _this.signedUp      = true;
                },
                function failureCallback( error )
                {
                    console.log( "onSubmit Failure: " + JSON.stringify( error ) );
                    if( error.response )
                        alert( 'Failure ' + error.response.message );
                    else if( error.message )
                        alert( 'Failure ' + error.message );
                    else
                        alert( 'Failure ' + JSON.stringify( error ) );
                }
            );
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onMounted()
    {
        this.recaptchaID = grecaptcha.render(
                                "patient-recaptcha",
                                {
                                    sitekey:    process.env.RECAPTCHA_SITE_KEY,
                                }
                            );
    }
</script>


// WEBPACK FOOTER //
// src/components/patient/patient-signup.vue